import { t } from "i18next"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeaderModal from "../components/headerModal"

import ManagerTimeslot from "../components/managerTimeslot";
import { hasModules } from "../utils/helpers";

const EditAgenda = () => {

  const { namePharmacy, user } = useSelector((state: any) => state.login);
  const navigate = useNavigate();

  const headerTitle = hasModules(user,'FEDERFARMA_DOCTOR') ? t('title-header-doctor', { fullname: [user?.name,user?.surname].join(' ') }) : t('title-header-modale', { nameBrand: namePharmacy })
  
  return (
    <>

      <HeaderModal textButtonRight={t('go-to-prenotations')} handleClick={() => { navigate('/prenotation') }} title={headerTitle} />
      <ManagerTimeslot />


    </>
  )
}

export default EditAgenda